import { EQUIPAMENTO_TIPOS, MAQUINA_TIPOS } from "@/services/locacoes";

/** Limite L/h sugerido por categoria de máquina (referência operacional). */
export const CONSUMO_LIMITE_PADRAO_POR_TIPO: Record<string, number> = {
  Escavadeira: 15,
  Retroescavadeira: 12,
  Motoniveladora: 10,
  "Pá Carregadeira": 14,
  "Rolo Compactador": 8,
  "Caminhão Basculante": 18,
  "Caminhão Pipa": 16,
  Munck: 14,
  Gerador: 6,
  Compressor: 5,
  Trator: 12,
  Container: 0,
  Baú: 0,
  "Módulo sanitário": 0,
  Escritório: 0,
  Depósito: 0,
  Outro: 0,
};

const TIPO_SLUG: Record<string, string> = {
  Escavadeira: "escavadeira",
  Retroescavadeira: "retroescavadeira",
  Motoniveladora: "motoniveladora",
  "Pá Carregadeira": "pa-carregadeira",
  "Rolo Compactador": "rolo-compactador",
  "Caminhão Basculante": "caminhao-basculante",
  "Caminhão Pipa": "caminhao-pipa",
  Munck: "munck",
  Gerador: "gerador",
  Compressor: "compressor",
  Trator: "trator",
  Container: "container",
  Baú: "bau",
  "Módulo sanitário": "modulo-sanitario",
  Escritório: "escritorio",
  Depósito: "deposito",
  Outro: "equipamento-outro",
};

export function defaultConsumoLimiteLphForTipo(tipo: string): number {
  const t = tipo.trim();
  if (!t) return 15;
  return CONSUMO_LIMITE_PADRAO_POR_TIPO[t] ?? 15;
}

export function getMaquinaTipoImagemUrl(tipo: string, tipoAtivo?: "maquinario" | "equipamento"): string {
  const t = tipo.trim();
  const slug = TIPO_SLUG[t];
  if (slug) return `/locacoes/tipos/${slug}.jpg`;
  if (tipoAtivo === "equipamento") return "/locacoes/tipos/equipamento-default.jpg";
  return "/locacoes/tipos/maquinario-default.jpg";
}

export const TIPOS_COM_IMAGEM = [...MAQUINA_TIPOS, ...EQUIPAMENTO_TIPOS] as const;
